import { Box, Grid, Link, Typography } from '@mui/material';
import Image from 'next/image';

const BlogContent = () => {
  return (
    <>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Box
          sx={{
            border: '1px solid #eaeaea',
            p: 1.5,
            backgroundColor: '#fff',
            pb: { xs: 2, sm: 2 },
            borderRadius: 3,
            minHeight: '100%',
          }}
        >
          <Link
            href="https://blog.taxzerone.com/posts/how-to-renew-form-2290-for-the-2026-tax-year/"
            target="_blank"
            sx={{
              color: '#333',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            <Box
              sx={{
                overflow: 'hidden',
                position: 'relative',
                border: '6px solid #42453f !important',
                borderRadius: 3,
                maxHeight: { xs: 183, sm: 134, md: 190, lg: 207 },
                mb: 2,
                '& img': {
                  transform: 'scale(1)',
                  transition: 'all .3s ease',
                  //  objectFit: 'cover',
                  width: '100%',
                  height: 'auto',
                },
                '& img:hover': { transform: 'scale(1.11)' },
              }}
            >
              <Image
                src="https://blog.taxzerone.com/wp-content/uploads/2290-for-2026.png"
                alt="How to renew Form 2290 for the 2026 Tax Year?"
                width={394}
                height={247}
              />
            </Box>

            <Typography
              variant="h3"
              sx={{
                fontFamily: 'Poppins',
                fontSize: { xs: 16, md: 16 },
                mb: { xs: 1, sm: 1 },
                fontWeight: 600,
                minHeight: { xs: 1, sm: 35 },
              }}
            >
              How to renew Form 2290 for the 2026 Tax Year?
            </Typography>

            <Typography
              variant="body2"
              sx={{
                fontFamily: 'Poppins',
                maxHeight: 'none',
                overflow: 'hidden',
                display: '-webkit-box',
                wordBreak: 'break-word',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                mt: 1,
              }}
            >
              <small
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontStyle: 'italic',
                }}
              >
                June 25, 2026
              </small>
              <br />
              Trucking businesses and owner-operators must file their Heavy
              Highway Vehicle Use Tax (HVUT) each year for IRS compliance.
            </Typography>
          </Link>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Box
          sx={{
            border: '1px solid #eaeaea',
            p: 1.5,
            backgroundColor: '#fff',
            pb: { xs: 2, sm: 2 },
            borderRadius: 3,
            minHeight: '100%',
          }}
        >
          <Link
            href="https://blog.taxzerone.com/posts/filing-form-2290-for-the-2026-27-tax-year-starts-now/"
            target="_blank"
            sx={{
              color: '#333',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            <Box
              sx={{
                overflow: 'hidden',
                position: 'relative',
                border: '6px solid #42453f !important',
                borderRadius: 3,
                maxHeight: { xs: 183, sm: 134, md: 190, lg: 207 },
                mb: 2,
                '& img': {
                  transform: 'scale(1)',
                  transition: 'all .3s ease',
                  //  objectFit: 'cover',
                  width: '100%',
                  height: 'auto',
                },
                '& img:hover': { transform: 'scale(1.11)' },
              }}
            >
              <Image
                src="https://blog.taxzerone.com/wp-content/uploads/form-2290-for-2026-27-tax-year.png"
                alt="Filing Form 2290 for the 2026-27 Tax Year starts now!"
                width={394}
                height={247}
              />
            </Box>

            <Typography
              variant="h3"
              sx={{
                fontFamily: 'Poppins',
                fontSize: { xs: 16, md: 16 },
                mb: { xs: 1, sm: 1 },
                fontWeight: 600,
                minHeight: { xs: 1, sm: 35 },
              }}
            >
              Filing Form 2290 for the 2026-27 Tax Year starts now!
            </Typography>

            <Typography
              variant="body2"
              sx={{
                fontFamily: 'Poppins',
                maxHeight: 'none',
                overflow: 'hidden',
                display: '-webkit-box',
                wordBreak: 'break-word',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                mt: 1,
              }}
            >
              <small
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontStyle: 'italic',
                }}
              >
                June 28, 2024
              </small>
              <br />
              The new tax season is upon us, and it’s time for truckers and
              fleet owners to file their Heavy Vehicle Use Tax (HVUT) Form 2290
              for the 2025-26 period.
            </Typography>
          </Link>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Box
          sx={{
            border: '1px solid #eaeaea',
            p: 1.5,
            backgroundColor: '#fff',
            pb: { xs: 2, sm: 2 },
            borderRadius: 3,
            minHeight: '100%',
          }}
        >
          <Link
            href="https://blog.taxzerone.com/posts/one-step-filing-for-your-2290-forms-with-automagic2290/"
            target="_blank"
            sx={{
              color: '#333',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            <Box
              sx={{
                overflow: 'hidden',
                position: 'relative',
                border: '6px solid #42453f !important',
                borderRadius: 3,
                maxHeight: { xs: 183, sm: 134, md: 190, lg: 212 },
                mb: 2,
                '& img': {
                  transform: 'scale(1)',
                  transition: 'all .3s ease',
                  //  objectFit: 'cover',
                  width: '100%',
                  height: 'auto',
                },
                '& img:hover': { transform: 'scale(1.11)' },
              }}
            >
              <Image
                src="https://blog.taxzerone.com/wp-content/uploads/automagic2290.png"
                alt="One-Step Filing for Your 2290 Forms with AutoMagic2290"
                width={394}
                height={251}
              />
            </Box>

            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: 16, md: 16 },
                mb: { xs: 1, sm: 1 },
                fontWeight: 600,
                minHeight: { xs: 1, sm: 35 },
              }}
            >
              One-Step Filing for Your 2290 Forms with AutoMagic2290
            </Typography>

            <Typography
              variant="body2"
              sx={{
                maxHeight: 'none',
                overflow: 'hidden',
                display: '-webkit-box',
                wordBreak: 'break-word',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                mt: 1,
              }}
            >
              <small
                style={{
                  fontWeight: 500,
                  fontStyle: 'italic',
                }}
              >
                August 23, 2024
              </small>
              <br />
              Filing the Heavy Vehicle Use Tax (HVUT) Form 2290 for USA truckers
              and owner-operators can often be time-consuming.
            </Typography>
          </Link>
        </Box>
      </Grid>
    </>
  );
};

export default BlogContent;
